import dashboardRoutes from './features/dashboard/routes';
import accountRoutes from './features/account/routes';
import errorRoutes from './features/error/routes';
import listingRoutes from './features/listings/routes';

const routes = [...dashboardRoutes, ...accountRoutes, ...listingRoutes, ...errorRoutes];

export default routes;
